module.exports = "<div class=\"ot-banner\" ng-class=\"{'ot-parallaxed': !!params.parallax}\" ng-style=\"vm.getSrc()\">\n  <h3 class=\"ot-title\">{{params.title}}</h3>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/common/banner.html
 ** module id = 248
 ** module chunks = 1
 **/